import axios from 'axios';
import * as types from './Layout.types';
import * as selectors from './Layout.selectors';
import { showNotification, empty } from './../../utils';
import * as dialog from '../common/dialog';
import * as loginActions from './../Login/Login.actions';

const apiUrl = process.env.REACT_APP_API_URL;

export const sendRequest = () => (dispatch, getState) => {
    const fields = selectors.getFields(getState());
    const files = selectors.getFiles(getState());
    const fittingMonth = selectors.getFittingMonth(getState());
    const fittingDate = selectors.getFittingDate(getState());

    if (fields.name === '') {
        return showNotification('Complete Information', 'Enter your name.', 'info');
    }
    if (fields.email === '') {
        return showNotification('Complete Information', 'Enter your email.', 'info');
    }
    if (fields.team_type === '') {
        return showNotification('Complete Information', 'Select "Your Team".', 'info');
    }
    if (fields.help_with_printing === '' && fields.help_with_promotional === '' && fields.help_with_apparel === '' && fields.help_with_fitting === '' && fields.help_with_other === '') {
        return showNotification('Complete Information', 'Select a "Help With" item.', 'info');
    }
    if (parseInt(fields.help_with_fitting) === 1) {
        if (fittingMonth === '') {
            return showNotification('Complete Information', 'Select the Month for the Fitting session.', 'info');
        }
        if (fittingDate === '') {
            return showNotification('Complete Information', 'Select the Date/Time for the Fitting session.', 'info');
        }
        if (fields.fitting_how_many_people === '') {
            return showNotification('Complete Information', 'Select the How many people for the Fitting session.', 'info');
        }
        if (parseInt(fields.fitting_apparel_type_scrubs) === 0 && parseInt(fields.fitting_apparel_type_polos) === 0 && parseInt(fields.fitting_apparel_type_jackets) === 0 && parseInt(fields.fitting_apparel_type_other) === 0) {
            return showNotification('Complete Information', 'Select at least one Type of Apparel for the Fitting session.', 'info');
        }
        if (parseInt(fields.fitting_style_men) === 0 && parseInt(fields.fitting_style_women) === 0 && parseInt(fields.fitting_style_both) === 0) {
            return showNotification('Complete Information', 'Select at least one Style/Fit for the Fitting session.', 'info');
        }
        if (fields.fitting_how_many_people >= 5) {
            if (fields.fitting_address === '') {
                return showNotification('Complete Information', 'Enter the Location Address for the Fitting session.', 'info');
            }
            if (fields.fitting_city === '') {
                return showNotification('Complete Information', 'Enter the Location City for the Fitting session.', 'info');
            }
            if (fields.fitting_state === '') {
                return showNotification('Complete Information', 'Enter the Location State for the Fitting session.', 'info');
            }
            if (fields.fitting_zip === '') {
                return showNotification('Complete Information', 'Enter the Location Zip for the Fitting session.', 'info');
            }
            if (fields.fitting_building_number === '') {
                return showNotification('Complete Information', 'Enter the Location Building/Room number for the Fitting session.', 'info');
            }
        }
    }
    if (fields.message === '') {
        return showNotification('Complete Information', 'Enter your message', 'info');
    }

    var formData = new FormData();
    for (const field in fields) {
        formData.append(field, fields[field]);
    }
    for (let i = 1; i <= files.length; i++) {
        formData.append('file' + i, files[i - 1]);
    }
    formData.append('filesLength', files.length);
    formData.append('fittingMonth', fittingMonth);
    formData.append('fittingDate', fittingDate);

    dispatch({ type: types.SEND_REQUEST, payload: null });
    axios.post(apiUrl + '/uthealth-help-requests', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SEND_REQUEST_SUCCESS, payload: response.data });
            showNotification('Success', 'Thank you for using our online help desk. Your request is being processed.', 'success', 6000);
            dispatch(dialog.actions.hideDialog('help-modal'));
            dispatch(clearFiles());
        })
        .catch((error) => {
            dispatch({ type: types.SEND_REQUEST_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchHelpRequestOpenTickets = () => (dispatch, getState) => {
    dispatch({ type: types.FETCH_HELP_REQUEST_OPEN_TICKETS, payload: null });
    axios.get(apiUrl + '/uthealth-help-request/open-tickets',
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_HELP_REQUEST_OPEN_TICKETS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_HELP_REQUEST_OPEN_TICKETS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkFittingMonth = () => (dispatch, getState) => {
    const fittingMonth = selectors.getFittingMonth(getState());
    if (empty(fittingMonth)) {
        return;
    }

    dispatch({ type: types.CHECK_FITTING, payload: null });
    axios.get(apiUrl + '/uthealth-help-request/check-fitting?month=' + fittingMonth,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_FITTING_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_FITTING_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_FIELD,
        payload: { field, value }
    });
}

export const addFile = (file) => (dispatch) => {
    dispatch({
        type: types.ADD_FILE,
        payload: file,
    });
}

export const removeFile = (index) => (dispatch) => {
    dispatch({
        type: types.REMOVE_FILE,
        payload: index,
    });
}

export const clearFiles = (index) => (dispatch) => {
    dispatch({
        type: types.CLEAR_FILES,
        payload: index,
    });
}

export const setFittingMonth = (value) => (dispatch) => {
    dispatch({
        type: types.SET_FITTING_MONTH,
        payload: value,
    });
}

export const setFittingDate = (value) => (dispatch) => {
    dispatch({
        type: types.SET_FITTING_DATE,
        payload: value,
    });
}

export const resetFields = (index) => (dispatch) => {
    dispatch({
        type: types.RESET_FIELDS,
        payload: index,
    });
}